import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ReportAgentResponseV4Schema } from "../response/ReportAgentResponseV4";
import { ReportAgentFilterV4Type } from "../schema/ReportAgentFilterSchemaV4"; // 1. Import tipe baru

const API_VERSION = 'v4';

// Hapus interface FilterProps yang lama

interface ReportAgentV4Props {
    filter?: ReportAgentFilterV4Type; // 2. Gunakan tipe yang sudah diimpor
    orderBy?: string;
    sort?: 'asc' | 'desc';
    type: string | null;
}

const useReportAgentV4 = (params: ReportAgentV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-agent',
            API_VERSION,
            params.type,
            JSON.stringify(params.filter),
            params.orderBy,
            params.sort,
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.post(`/${API_VERSION}/channel-manager/group-report-agent`, {
                    filter: params.filter,
                    orderBy: params.orderBy,
                    sort: params.sort,
                });

                const validationResult = ReportAgentResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Agent report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Agent report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && params.type === "report_agent",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useReportAgentV4;